var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { computed, createApp, ref, watch } from "vue";
import ProductCardApp from "./ProductCardApp.vue";
import { extractAppData, isWebpSupported } from "../../../utils";
import { hidePreloader } from "../../../components/preloader";
import useProductApi from "../api/productApi";
import { getCartOffersList } from "../../../components/cart";
import EventBus from "../../../events/EventBus";
import SetCardApp from "./SetCardApp.vue";
var thumbsSlider;
var productSlider;
export function initSetCardApp() {
    return __awaiter(this, void 0, void 0, function () {
        var el, deliveryEl, data;
        return __generator(this, function (_a) {
            el = document.getElementById('setCardApp');
            deliveryEl = document.getElementById('deliveryContainer');
            if (!el || !deliveryEl) {
                return [2 /*return*/];
            }
            data = extractAppData(el);
            createApp(SetCardApp, __assign(__assign({}, data), { deliveryEl: deliveryEl })).mount(el);
            return [2 /*return*/];
        });
    });
}
export function initProductOfferApp(bigSwiper, smallSwiper) {
    return __awaiter(this, void 0, void 0, function () {
        function updateDescription() {
            if (product.category === 'perfume') {
                description.innerHTML = type.value ? type.value.name : '';
            }
            textElement.innerHTML = page.value.text;
        }
        var el, newInterfaceTrigger, description, slide, thumbSlide, textElement, data, appData, pages, product, type, offer, interacted, cartOffers, page;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    el = document.getElementById('productOfferApp');
                    newInterfaceTrigger = document.getElementById('offer-mode-switch');
                    description = document.getElementById('product_description');
                    slide = document.querySelector('#prod-item-swiper .swiper-slide:first-child');
                    thumbSlide = document.querySelector('#prod-nav-swiper .swiper-slide:first-child');
                    textElement = document.getElementById('product_text');
                    if (!el || !newInterfaceTrigger || !description || !slide || !thumbSlide || !textElement) {
                        return [2 /*return*/];
                    }
                    thumbsSlider = smallSwiper;
                    productSlider = bigSwiper;
                    data = extractAppData(el);
                    return [4 /*yield*/, useProductApi(data.productId).request()];
                case 1:
                    appData = _a.sent();
                    pages = appData.pages, product = appData.product;
                    type = ref(data.activeType ? appData.types.find(function (t) { return data.activeType === t.id; }) : null);
                    offer = ref(data.activeOffer ? product.offers.find(function (o) { return data.activeOffer === o.id; }) : null);
                    interacted = ref(data.activeType !== null || data.activeOffer !== null);
                    cartOffers = ref(getCartOffersList());
                    page = computed(function () { return type.value && pages[type.value.id] ? pages[type.value.id] : pages[product.id]; });
                    EventBus.on('cart:update', function (offers) { return cartOffers.value = offers; });
                    createApp(ProductCardApp, {
                        coupon: appData.coupon,
                        product: appData.product,
                        types: appData.types,
                        delivery: data.delivery,
                        newInterface: newInterfaceTrigger.checked,
                    }).provide('type', type).provide('offer', offer).provide('cart', cartOffers).provide('interacted', interacted).mount(el);
                    watch([type, offer, interacted], function (_a) {
                        var _b = __read(_a, 3), type = _b[0], offer = _b[1], interacted = _b[2];
                        if (!interacted) {
                            return;
                        }
                        history.replaceState(undefined, undefined, buildUrl(product.url, type, offer));
                        updateDescription();
                        if (offer === null || offer === void 0 ? void 0 : offer.image) {
                            updateImage(offer.image);
                        }
                        else if (page.value.image && page.value.image.big.webp.hiDPI !== product.image.big.webp.hiDPI) {
                            updateImage(page.value.image);
                        }
                        else {
                            updateImage();
                        }
                    });
                    hidePreloader(false, el);
                    return [2 /*return*/];
            }
        });
    });
}
function buildUrl(baseUrl, type, offer) {
    var url = baseUrl;
    if (type) {
        url += "".concat(type.code, "/");
    }
    if (offer) {
        url += "?offer=".concat(offer.id);
    }
    return url;
}
function updateImage(image) {
    if (image === void 0) { image = null; }
    var extension = isWebpSupported() ? 'webp' : 'jpeg';
    var offerSlide = productSlider.wrapperEl.querySelector('.prod-slider__item--offer');
    var thumbOfferSlide = thumbsSlider.wrapperEl.querySelector('.prod-cover-nav__item--offer');
    if (image) {
        var slide = "\n      <a href=\"".concat(image.big[extension].hiDPI, "\" class=\"prod-slider__link\" tabindex=\"0\" data-pswp-width=\"").concat(image.width, "\" data-pswp-height=\"").concat(image.height, "\">\n        ").concat(makePicture(image.big, image.mobile), "\n      </a>\n    ");
        if (!offerSlide) {
            productSlider.prependSlide("<div class=\"prod-slider__item swiper-slide prod-slider__item--offer\">".concat(slide, "</div>"));
            thumbsSlider.prependSlide("<div class=\"prod-cover-nav__item prod-cover-nav__item--offer swiper-slide\">".concat(makePicture(image.tiny), "</div>"));
            productSlider.slideTo(0);
        }
        else {
            offerSlide.innerHTML = slide;
            thumbOfferSlide.innerHTML = makePicture(image.tiny);
            productSlider.slideTo(0);
        }
    }
    else if (offerSlide) {
        productSlider.slideTo(1);
        productSlider.removeSlide(0);
        thumbsSlider.removeSlide(0);
    }
}
function makePicture(image, mobileImage) {
    if (mobileImage === void 0) { mobileImage = null; }
    var ext = isWebpSupported() ? 'webp' : 'jpeg';
    return "\n    <picture>\n      ".concat(mobileImage ? "<source type=\"image/".concat(ext, "\" media=\"(max-width: 450px)\" srcset=\"").concat(mobileImage[ext].loDPI, ", ").concat(mobileImage[ext].hiDPI, " 2x\">") : '', "\n      <img src=\"").concat(image[ext].loDPI, "\" srcset=\"").concat(image[ext].hiDPI, " 2x\" alt=\"\">\n    </picture>\n  ");
}
